import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Cpu, Sparkles, CheckCircle } from 'lucide-react';

const steps = [
  {
    icon: FileText,
    title: 'Enter Your Details',
    description: 'Fill in your role, industry, target audience, and professional goals.',
  },
  {
    icon: Cpu,
    title: 'AI Analysis',
    description: 'Our algorithm analyzes your inputs and maps them to LinkedIn search patterns.',
  },
  {
    icon: Sparkles,
    title: 'Generate Headlines',
    description: 'Get 10 unique, optimized headlines across different styles and approaches.',
  },
  {
    icon: CheckCircle,
    title: 'Copy & Use',
    description: 'Choose your favorite headline and paste it directly into your LinkedIn profile.',
  },
];

export const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-16 md:py-24 bg-gradient-to-b from-background to-muted/20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4">
            How It Works
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Generate your perfect LinkedIn headline in four simple steps
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="relative group"
            >
              <div className="relative bg-card border border-border rounded-2xl p-6 h-full hover:border-primary/30 hover:shadow-lg transition-all duration-300">
                {/* Step number badge */}
                <div className="absolute -top-3 left-6 w-7 h-7 rounded-full bg-primary text-primary-foreground text-sm font-bold flex items-center justify-center shadow-md">
                  {index + 1}
                </div>
                
                <div className="flex flex-col items-center text-center pt-2">
                  <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
                    <step.icon className="w-6 h-6 text-primary" />
                  </div>
                  <h3 className="font-display text-lg font-semibold text-foreground mb-2">
                    {step.title}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
